import queryKeys from '@/constants/queryKeys';
import { peerSupportEngagementGet } from '@/services/api/requests/organization';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

const usePeerSupportEngagement = (month: string) => {
  const { isLoading, data, isError, error, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.peerSupport.engagement, month],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const response = await peerSupportEngagementGet(month);

      return response;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch };
};

export default usePeerSupportEngagement;
